$(document).ready(function(){
	var menu_expand_btn = $('.menu_expand');
	menu_expand_btn.attr('href','javascript:void(1)');
var site_menu = $('.nav-menu');


menu_expand_btn.click(function(){//state-active
	//site_menu.slideToggle(140, function(){site_menu.removeAttr('style');site_menu.toggleClass('state-active')});
	site_menu.toggleClass('state-active');
	$(this).toggleClass('active');
	$("body").addClass('no_overflow');
	$("body").children(".overlay").addClass('active');
		$("body").css("position","relative");

	});
	$(".overlay").on('click',function(){
		$(this).removeClass('active');
	$("body").removeClass('no_overflow');
		$(".site-menu").children().children(".nav-menu").removeClass("state-active");
	});


	//sub menu plus drop

	var item_with_children = $('.nav-menu li.menu-item-has-children');

	item_with_children.prepend('<span class="expand_plus"><i></i></span>');

	  $('.expand_plus').on('click',function(){
		$(this).toggleClass('active');
		$(this).parent().children('.sub-menu').slideToggle(240, function(){$(this).parent().children('.sub-menu').removeAttr('style'); $(this).parent().children('.sub-menu').toggleClass('active-children');  });
		});
	  

 $=jQuery;

$(document).ready(function() {

$(".nav-menu").append("<div class='cross_button afclr'><a><i class='m_close_icon' aria-hidden='true'></i></a></div>");

$(".cross_button").on('click',function(){

$(".nav-menu").removeClass("state-active");

$(".overlay").removeClass("active");

$("body").removeClass('no_overflow');

$(".cross_button").closest(".body_shift").parent().removeClass("no_overflow");

});

});

  $(".search__icon_").on('click',function(){
      $('.search__form__sec').slideToggle();
  });
  
});


  
  $(function() {
    $('.t_shirt_box_inner').matchHeight();
    $('.footer_link_heading').matchHeight();
    //$('.best_seller_title').matchHeight();
    //$('.reviews_content_pera').matchHeight();

});

$(document).ready(function() {
  var swiper = new Swiper(".remember-swiper", {
    slidesPerView: 2,
    spaceBetween: 40,
    speed:1000,
    loop: true, 
    navigation: {
      nextEl: ".remember-next",
      prevEl: ".remember-prev",
    },
    autoplay: {
      delay: 3000,   
    },
    breakpoints: {
	        320: {
            slidesPerView: 1,
                spaceBetween: 10,
              },
              479: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
              993: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              
            }
          });
          
          var swiper = new Swiper(".best-seller-swiper", {
            slidesPerView: 5.3,
            spaceBetween: 40,
            centeredSlides: true,
            speed:1000,
            loop: true, 
            autoplay: {
      delay: 3000,   
    },
    breakpoints: {
      340: {
                slidesPerView: 1.5,
                spaceBetween: 10,
              },
              480: {
                slidesPerView: 2.5,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 3.6,
                spaceBetween: 10,
              },
            993: {
              slidesPerView: 4.3,
              spaceBetween: 20,
            },
            
          }
  });
  
  var swiper = new Swiper(".banner-swiper", {
    slidesPerView: 2.8,
    spaceBetween: 40,
    // centeredSlides: true,
    speed:1000,
    loop: true, 
    pagination: {
      el: ".banner-pagination",
    },
    autoplay: {
      delay: 3000,   
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      480: {
        slidesPerView: 1.5,
        spaceBetween: 10,
      },
      767: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      993: {
        slidesPerView: 2.8,
        spaceBetween: 20,
      },
    }
  });
  
  var swiper = new Swiper(".reviews-swiper", {
    slidesPerView: 3,
    spaceBetween: 40,
    // centeredSlides: true,
    speed:1000,
    loop: true, 
    navigation: {
      nextEl: ".reviews-next",
      prevEl: ".reviews-prev",
    },
    autoplay: {
      delay: 3000,   
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      479: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      767: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      993: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      
    }
  });
  
});


$(document).ready(function() {
  var three_menu_item_has_children = $('.nav-menu li.three-menu-item-has-children');
	three_menu_item_has_children.prepend('<span class="expand_plus expand_plus_for_three_ul"><i></i></span>');
  
  $('.expand_plus_for_three_ul').on('click',function(){
		$(this).toggleClass('active');
		$(this).parent().children('ul').slideToggle(240, function(){$(this).parent().children('.sub-menu').removeAttr('style'); $(this).parent().children('.sub-menu').toggleClass('active-children');  });
		});
  
});